import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { MovableModalContainer } from 'components/MovableModal'
import { selectActiveCepExtensions } from '~/selectors/adobeCepExtentions'
import { closeCepExtension } from '~/actions/adobeCepExtentions'
import { ReactComponent as CloseIcon } from '~/assets/settings/navigation_close.svg'
import './ActiveCepExtensions.scss'

const CepExtensionPanel = ({ extension, onClose }) => (
  <div className="cep-extension-panel">
    <div className="cep-extension-header">
      <span className="cep-extension-title allow-draggable">{extension.menu}</span>
      <div className="cep-extension-close" onClick={() => onClose(extension.menu)}>
        <CloseIcon />
      </div>
    </div>
    <iframe
      title={extension.menu}
      src={`/adobe-cep/${extension.extensionRoot}/${extension.mainPath}`}
      className="cep-extension-iframe"
    />
  </div>
)

const CepExtensionFullscreen = ({ extension, onClose }) => (
  <div className="cep-extension-fullscreen">
    <div className="cep-extension-header">
      <span className="cep-extension-title">{extension.menu}</span>
      <div className="cep-extension-close" onClick={() => onClose(extension.menu)}>
        <CloseIcon />
      </div>
    </div>
    <iframe
      title={extension.menu}
      src={`/adobe-cep/${extension.extensionRoot}/${extension.mainPath}`}
      className="cep-extension-iframe"
    />
  </div>
)

const ActiveCepExtensions = () => {
  const activeExtensions = useSelector(selectActiveCepExtensions)
  const dispatch = useDispatch()

  const handleClose = extensionId => {
    dispatch(closeCepExtension(extensionId))
  }

  if (activeExtensions.length === 0) {
    return null
  }

  return (
    <>
      {activeExtensions.map(ext => (
        ext.geometry ? (
          <MovableModalContainer
            key={ext.menu}
            visible
            width={ext.geometry.width}
            height={ext.geometry.height}
            restorePosition={false}
            windowId={`cep-extension-${ext.menu}`}
            onCloseWindow={() => handleClose(ext.menu)}
          >
            <CepExtensionPanel extension={ext} onClose={handleClose} />
          </MovableModalContainer>
        ) : (
          <CepExtensionFullscreen
            key={ext.menu}
            extension={ext}
            onClose={handleClose}
          />
        )
      ))}
    </>
  )
}

export default ActiveCepExtensions
